import { PrintComponent } from '../../app-lite/table/cell-components/actions/print.component';

export function InspectionsBoxCtrl (
  $scope,
  $state,
  $translate,
  $window,
  API
) {
  $scope.showInspections = !!$scope.inspections.length;

  $scope.tableSettings = {
    columns: [
      {
        field : 'inspection_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.NUMBER')
        }
      },
      {
        field : 'inspection_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'inspection_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'inspectionStatus'
      },
      {
        field : 'contact_name',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.CONTACT')
        }
      },
      {
        field : 'contact_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.CONTACT_NO')
        },
        pipe: 'phone'
      },
      {
        field : 'contact_email',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.CONTACT_EMAIL')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onPrintClick: event => $scope.printInspection(event)
            }
          },
          enabled: true,
          factory: PrintComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INSPECTIONS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.inspection', {
      customer_id: event.row.customer_id,
      vehicle_id : event.row.vehicle_id,
      id         : event.row.id
    });
  };

  $scope.printInspection = function ( inspection ) {
    $window.open(`${API.url}/reports/jasper_inspection/${ inspection.id }.pdf`, '_blank');
  };
};